import React from 'react'
import '../styles/layout/About.css'
import { Container, Image } from 'react-bootstrap';
import whoweAre from '../assests/who-we-are.png'
import whatWeDo from '../assests/what-we-do.png'

const Aboutus = () => {
  return (
    <section className="section section--defer aboutIntro">
      <Container>
        <div className="split whoweAre">
          <div className="split__media reveal reveal--media">
            <Image src={whoweAre} className="img-fluid" alt="" />
          </div>
          <div className="split__copy reveal reveal--right" data-delay="1">
            <h2>Who We Are</h2>
            <span className="rule" />
            <p>Founded by team of seasoned bankers with over 120 years of collective experience in banking,
              financial services and cards, encompassing strategy, operations, marketing, risk & technology,
              both in India and internationally.
            </p>
          </div>
        </div>
        <div className="split split--flip whatWeDo">
          <div className="split__media reveal reveal--media" data-delay="1">
            <Image src={whatWeDo} className="img-fluid" alt="" loading="lazy" />
          </div>
          <div className="split__copy reveal reveal--left">
            <h2>What We Do</h2>
            <span className="rule" />
            <p>We offer credit card processing solutions that can help you in effectively managing your
              credit card portfolio end-to-end. These solutions are customised to meet the unique strategic,
              operational and compliance requirements of each bank.
            </p>
          </div>
        </div>
      </Container>
    </section>
  )
}

export default Aboutus
